import { api } from "../../api/api";

export interface IOrgEnvConfig {
  env_key: string;
  env_value: string;
}

interface IFetchOrgEnvConfigParams {
  companyOutletUuid: string;
  env_key?: string;
}

export const fetchOrgEnvConfigListService = async ({
  companyOutletUuid,
  env_key,
}: IFetchOrgEnvConfigParams): Promise<IOrgEnvConfig[]> => {
  let finalUrl = `/siteConfiguration/get-company-outlet-env?company_outlet_uuid=${companyOutletUuid}`;

  if (env_key) {
    finalUrl += `&env_key=${env_key}`;
  }

  const res = await api.get(finalUrl);

  return res.data?.data ?? [];
};
